import {post,get} from '../index'
export const address={
// 地址列表
    addressList(params){
        return get('/address/list',params)
    },
    // 地址添加
    addressAdd(params){
        return post('/address/addoredit',params)
    },
    //默认地址
    addressDefault(params){
        return get('address/default',params)
    },
    // 运费计算
    calculateFreight(params){
        return get('order/calculate_freight',params)
    },
    uploadFile(params){
        return get('upload/file')
    },
    getAddressDel(params){
        return post('address/del',params)
    }

}


// WEBPACK FOOTER //
// ./src/api/http/address.js